import { SvgIcon } from '@mui/material';

import { ModifiedMuiIconProps } from '../../interfaces';

const RemoveCircleIcon: React.FC<ModifiedMuiIconProps> = ({
  color,
  backgroundColor,
  ...rest
}) => {
  return (
    <SvgIcon
      className="MuiSvgIcon-root MuiSvgIcon-fontSizeLarge css-tzssek-MuiSvgIcon-root"
      focusable="false"
      aria-hidden="true"
      viewBox="0 0 24 24"
      {...rest}
    >
      <path
        d="M 11.5 2.5 C 6.532 2.5 2.5 6.532 2.5 11.5 s 4.032 9 9 9 s 9 -4.032 9 -9 S 16.468 2.5 11.5 2.5"
        fill={backgroundColor}
      ></path>
      <path
        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z"
        fill={color}
      ></path>
    </SvgIcon>
  );
};

export default RemoveCircleIcon;
